module.exports = __webpack_public_path__ + "static/909946486-wide.ca7fad3c.jpg";